// extracted by mini-css-extract-plugin
module.exports = {"buttonSalvarPDF":"styles_buttonSalvarPDF__2--7A"};